import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import InspectionReadinessSupport from "@/pages/InspectionReadinessSupport";

export const Route = createFileRoute("/en/services/quality-assurance/regulatory-inspection-readiness")({
  head: () => buildRouteHead("/en/services/quality-assurance/regulatory-inspection-readiness"),
  component: InspectionReadinessSupport,
});
